import { render, staticRenderFns } from "./LocationModal.vue?vue&type=template&id=39893488&lang=pug"
import script from "./LocationModal.vue?vue&type=script&lang=js"
export * from "./LocationModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports